import React from 'react';
import { ContextElement } from '../../schema/context.schema';
import styles from '../../assets/css/context.module.css';
import FormElementComponent from '../form/FormElement';
import { FormDataValue } from '../../hooks/useFormData';
import { InputElement } from '../../schema/input.schema';
import { TextElement } from '../../schema/text.schema';
import Input from '../input/Input';

interface ContextComponentProps {
	element: ContextElement;
	onChange: (key: string, value: FormDataValue) => void;
	onValidationChange: (key: string, value: boolean) => void;
}

const ContextComponent: React.FC<ContextComponentProps> = ({ element, onChange, onValidationChange }) => {
	const { tags, content } = element;

	const containerClassName = getContextContainerClassName(tags);
	if (content.length === 2) {
		const [firstElement, secondElement] = content;
		if (
			(firstElement.type === 'input' &&
				secondElement.type === 'text' &&
				secondElement.tags &&
				secondElement.tags.includes('HELPTEXT')) ||
			(secondElement.type === 'input' &&
				firstElement.type === 'text' &&
				firstElement.tags &&
				firstElement.tags.includes('HELPTEXT'))
		) {
			const inputElement = firstElement.type === 'input' ? firstElement : secondElement;
			const textElement = firstElement.type === 'text' ? firstElement : secondElement;
			const helpText = (textElement as TextElement).content || '';
			return (
				<div className={styles['context-child-container']}>
					<Input
						element={inputElement as InputElement}
						info={helpText}
						onChange={onChange}
						onValidationChange={onValidationChange}
					/>
				</div>
			);
		}
	}

	return (
		<div className={`${styles['context-container']} ${containerClassName}`}>
			{content.map((childElement, index) => (
				<div key={index} className={styles['context-child-container']}>
					<FormElementComponent
						element={childElement}
						onChange={onChange}
						onValidationChange={onValidationChange}
					/>
				</div>
			))}
		</div>
	);
};

interface TagClassMap {
	[key: string]: string;
}

const tagClassMap: TagClassMap = {
	CAPTCHA: styles['captcha'],
	BOX_SUCCESS: styles['box-success'],
	BOX_INFO: styles['box-info'],
	BOX_WARNING: styles['box-warning'],
	BOX_DANGER: styles['box-danger']
};

const getContextContainerClassName = (tags: Array<string>): string => {
	let containerClassName = '';

	tags.forEach((tag) => {
		if (tag in tagClassMap) {
			containerClassName += ` ${tagClassMap[tag]}`;
		}
	});

	return containerClassName;
};

export default ContextComponent;
